/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetSuggestionMessage extends IMessage {
	id: string;
	documentId: string;
}

export default class GetSuggestionMessage extends Message {
	public static readonly TYPE: string = '103';

	public static readonly READABLE_TYPE_NAME: string = 'getSuggestion';

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesGetSuggestionMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor( public readonly id: string, public readonly documentId: string ) {
		super();
	}

	public toJSON(): IGetSuggestionMessage {
		return {
			id: this.id,
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IGetSuggestionMessage ): GetSuggestionMessage {
		return new GetSuggestionMessage( object.id, object.documentId );
	}
}
